import { render } from "./ElementCollection.vue?vue&type=template&id=abc21174"
import script from "./ElementCollection.vue?vue&type=script&lang=js"
export * from "./ElementCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__